import type {
    AccountSingleStepPinRequest,
    AuthResponse,
    ChangePinRequest,
    CreatePinRequest,
    CurrencyInfo,
    JWTLoginRequest,
    ReCreatePinRequest,
    SessionInfoDTO,
} from '@leanpay/models'
import { HttpClient } from '@leanpay/http-client'
import { storage } from '@leanpay/local-storage'
import { STORAGE_KEY } from '@leanpay/utils'

import { vendorErrorHandler } from '../errorHandler'
import { clientInterceptor } from '../interceptors'

class DashboardService {
    _httpClient = new HttpClient({
        config: { baseURL: undefined },
        interceptorConfig: {
            onRequestFulfilled: clientInterceptor as any,
            onRejected: vendorErrorHandler,
        },
    })

    private _sessionCheckUrl = 'api/session-info'
    private _authenticateUrl = 'api/authenticate'
    private _currencyUrl = 'api/currency'
    private _requestOtpUrl = 'api/account/single-step/request-pin'
    private _resendOtpUrl = 'api/account/single-step/resend-pin'
    private _resendOtpOverVoiceUrl = 'api/account/single-step/resend-pin-over-voice'
    private _createPinUrl = 'api/authenticate/pin/create'
    private _recreatePinUrl = 'api/authenticate/pin/recreate'
    private _changePinUrl = 'api/authenticate/pin/change'

    async getSessionInfo() {
        const { data } = await this._httpClient.get<SessionInfoDTO>(this._sessionCheckUrl)
        storage.save(STORAGE_KEY.SESSION_INFO, data)
        return data
    }

    async getCurrencyFromServer() {
        const { data } = await this._httpClient.get<CurrencyInfo>(this._currencyUrl)

        return data
    }
    async createPin(request: CreatePinRequest) {
        const { data } = await this._httpClient.post(this._createPinUrl, request)

        return data
    }
    async changePin(request: ChangePinRequest) {
        const { data } = await this._httpClient.post(this._changePinUrl, request)

        return data
    }
    async recreatePin(request: ReCreatePinRequest) {
        const { data } = await this._httpClient.post(this._recreatePinUrl, request)

        return data
    }

    async requestOtp(request: AccountSingleStepPinRequest) {
        const { data } = await this._httpClient.post(this._requestOtpUrl, request)
        return data
    }

    async resendOtp(phoneNumber: string) {
        const request: AccountSingleStepPinRequest = {
            phoneNumber: phoneNumber,
        }

        const { data } = await this._httpClient.post(this._resendOtpUrl, request)
        return data
    }

    async resendOtpOverVoice(phoneNumber: string) {
        const request: AccountSingleStepPinRequest = {
            phoneNumber: phoneNumber,
        }

        const { data } = await this._httpClient.post(this._resendOtpOverVoiceUrl, request)

        return data
    }
    async authenticate(payload: JWTLoginRequest): Promise<AuthResponse> {
        const res = await this._httpClient.post<AuthResponse>(this._authenticateUrl, payload)

        return res.data
    }
}

export const dashboardService = new DashboardService()
